  <template>
  <Transition name="fade">
    <div v-if="show" class="modal-wrapper" @click.self="closeModal">
      <div class="restaurant-closed-modal">
        <div class="restaurant-closed-modal__close" @click="closeModal">
          <Icons variant="close" />
        </div>
        <div class="restaurant-closed-modal__icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="#DB4723"/>
          </svg>
        </div>
        <div class="restaurant-closed-modal__title">{{ title || $t('restaurantClosed.title') }}</div>
        <div v-if="message" class="restaurant-closed-modal__message">{{ message }}</div>
        <div v-if="!title" class="restaurant-closed-modal__subtitle">{{ $t('restaurantClosed.subtitle') }}</div>
        <div class="restaurant-closed-modal-buttons">
          <div class="btn" @click="closeModal">{{ $t('restaurantClosed.ok') }}</div>
        </div>
      </div>
    </div>
  </Transition>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import Icons from '@/components/UI/Icons/';

const emit = defineEmits<{ close: [] }>();
const show = ref(false);
const message = ref('');
const title = ref('');

function showModal(msg?: string | null, customTitle?: string | null) {
    message.value = msg || '';
    title.value = customTitle || '';
    show.value = true;
}

function closeModal() {
    show.value = false;
    emit('close');
}

defineExpose({ showModal });
</script>
<style scoped lang="scss">
.restaurant-closed-modal {
    position: relative;
    padding: 48px 32px 32px 32px;
    width: 620px;
    max-width: 90vw;
    max-height: 90dvh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    background: var(--color-white);
    border-radius: 30px;

    &__close {
        position: absolute;
        top: 32px;
        right: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 48px;
        height: 48px;
        color: var(--color-red);
        border: 2px solid var(--color-red);
        box-shadow: 1px 1px 6px 0 #002D1D0D;
        border-radius: 50%;
        cursor: pointer;
    }

    &__icon {
        margin-bottom: 20px;
    }

    &__title {
        margin-bottom: 12px;
        font-size: 32px;
        font-weight: 700;
    }

    &__message {
        margin-bottom: 12px;
        font-size: 22px;
        color: var(--color-dark-grey);
        white-space: pre-line;
        overflow-wrap: anywhere;
    }

    &__subtitle {
        margin-bottom: 32px;
        font-size: 22px;
    }

    &-buttons {
        width: 100%;

        & .btn {
            height: 64px;
        }
    }
}
</style>
